import { Link } from "react-router-dom"
import Modal from "../General/Modal"
import JOTLogo from "../Icons/JOTLogoLineFlossiGrey.png"

const JOTJarInfoModal = ({setShowJOTJarInfoModal}: {setShowJOTJarInfoModal: (show: boolean) => void}) => {

  // const headingClass = "text-center bg-my-olive text-white text-md uppercase p-2 border border-my-grey border-b-0"
  // const subHeadingClass = "text-left bg-my-olive text-white capitalize p-1 border border-my-grey font-normal"
  // const cellClass = "p-1 border border-my-grey text-left"

  return <Modal
    closeFunction={() => setShowJOTJarInfoModal(false)}
    title={<img src={JOTLogo} className="h-14 mx-auto" alt="JUST ONE Tree" />}
  >
    <div className="space-y-2 p-2 text-left text-sm">
      <p>
        Flossi is partnered with JUST ONE Tree to provide the opportunity for contributors to donate trees as part of their contribution to your jar.
      </p>
      <ul className="list-disc list-inside px-2">
        <li>It costs £1 to plant a tree with JUST ONE Tree.</li>
        <li>JUST ONE Tree donations are exempt from any Flossi service fee (i.e. it will only cost your contributors £1 per tree).</li>
        <li>100% of the donation goes to JUST ONE Tree.</li>
      </ul>
      <h2 className="underline font-bold">
        How Does It Work?
      </h2>
      <p>
        If enabled:
      </p>

      <ul className="list-disc list-inside px-2">
        <li>Your jar's 'contribution page' will feature the option for your contributors to donate trees.</li>
        <li>Your jar 'overview page' will feature a 'Tree Counter' to inform you of how many trees you have facilitated the planting of.</li>
      </ul>
      <h2 className="underline font-bold">
        Who Are JUST ONE Tree?
      </h2>
      <p>
        JUST ONE Tree are a non-profit organisation dedicated to combating climate change through <span className="font-bold">global reforestation</span> and <span className="font-bold">ocean restoration</span>. Find out more here:
      </p>
      <ul>
        <li>Website: <a href="https://www.justonetree.life/" target="_blank" rel="noreferrer" className="text-my-olive hover:text-my-orange underline">www.justonetree.life</a></li>
        <li>Instagram: <a href="https://www.instagram.com/just_one_tree" target="_blank" rel="noreferrer" className="text-my-olive hover:text-my-orange underline">@just_one_tree</a></li>
        <li>Facebook: <a href="https://www.facebook.com/JUSTONETree.life" target="_blank" rel="noreferrer" className="text-my-olive hover:text-my-orange underline">@justonetree.life</a></li>
        <li>Twitter (X): <a href="https://x.com/just_one_tree" target="_blank" rel="noreferrer" className="text-my-olive hover:text-my-orange underline">@just_one_tree</a></li>
      </ul>
      <p>We hope this provides clarity. If not, please feel free to <Link to="/contact-us" className="text-my-olive hover:text-my-orange underline">contact us</Link> for further information.</p>
    </div>
  </Modal>
}

export default JOTJarInfoModal